import { useCallback } from 'react'
import { closeDeleteDialogActionCreator } from '../../../state'
import { deleteActivityType } from '../../../effects'
import { useActivityTypesContext } from '../../../context'
import { useIsUnmounted } from '@sales-center/components'

export function useHandlers() {
  const [state, dispatch] = useActivityTypesContext()
  const { underDeletion } = state
  const isUnmounted = useIsUnmounted()

  const handleCancelClick = useCallback(() => {
    dispatch(closeDeleteDialogActionCreator())
  }, [dispatch])

  const handleDeleteClick = useCallback(async () => {
    if (underDeletion) {
      const action = await deleteActivityType(underDeletion)

      if (isUnmounted()) return

      dispatch(action)
    }
  }, [dispatch, isUnmounted, underDeletion])

  return {
    handleCancelClick,
    handleDeleteClick,
  }
}
